import { log } from './log';

export function waitForCommitToBeReady()
{
    log('info', 'lifecycle::waitForCommitToBeReady');

    return null;
}
